export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-8 max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 bg-background-100 rounded-2xl p-8 md:p-12 border border-background-200/70 overflow-hidden relative">
          <div className="flex-1 text-center lg:text-left relative z-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              随时随地，畅快吃瓜
            </h2>
            <p className="text-sm text-foreground-500 leading-relaxed mb-6 max-w-md mx-auto lg:mx-0">
              91吃瓜移动端入口现已开放，无论你在地铁上、午休时还是睡前刷一刷，
              最新热点随时掌握，吃瓜节奏永不掉队。打开手机浏览器即可访问，无需下载安装。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#hero"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-7 py-3 bg-primary-500 text-background-50 font-medium rounded-full hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap text-sm cursor-pointer"
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-smartphone-line text-sm"></i>
                </span>
                立即体验
              </a>
              <span className="text-xs text-foreground-400">
                无需下载 · 浏览器打开即用
              </span>
            </div>
          </div>
          <div className="flex-shrink-0 relative">
            <div className="w-[200px] h-[360px] bg-secondary-200 rounded-3xl overflow-hidden shadow-lg border-4 border-background-50">
              <div className="w-full h-full bg-secondary-300 flex flex-col items-center justify-center p-4">
                <div className="text-primary-500 text-sm font-heading font-bold mb-3">91吃瓜</div>
                <div className="w-full space-y-2">
                  <div className="w-full h-2 bg-primary-200/50 rounded-full"></div>
                  <div className="w-3/4 h-2 bg-accent-200/50 rounded-full"></div>
                  <div className="w-full h-2 bg-secondary-400/50 rounded-full"></div>
                  <div className="w-1/2 h-2 bg-primary-200/50 rounded-full"></div>
                  <div className="w-full h-2 bg-accent-200/50 rounded-full mt-3"></div>
                  <div className="w-5/6 h-2 bg-secondary-400/50 rounded-full"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}